export function isMerry() {
    return new Date().getMonth() === 11;
}
